<template>
  <div v-if="establishment && establishment.id">
    <h4>{{ $t('importTrainingPlan') }}</h4>
    <div :class="{ 'box-block': !trainee }">
      <div v-if="monitor.visible" :class="monitor.type" class="alert">
        {{ monitor.message }}
      </div>
      <div>
        <ValidationObserver ref="form">
          <div>
            <div
              class="alert"
              :class="importPlanForm.alert.type"
              v-if="importPlanForm.alert.on"
            >
              {{ importPlanForm.alert.text }}
            </div>
            <validation-provider
              name="file"
              rules="required"
              v-slot="{ errors }"
              class="w-100"
            >
              <div class="dropbox" :class="{ 'is-invalid': errors.length }">
                <input type="hidden" v-model="importPlanForm.file" />
                <input
                  type="file"
                  id="assetsFieldHandle"
                  class="overflow-hidden position-absolute"
                  style="visibility: hidden"
                  @change="filePlanChange"
                  accept=".xlsx, .xls"
                />

                <label
                  for="assetsFieldHandle"
                  :class="{ 'is-invalid': errors.length }"
                  class="d-block"
                >
                  <div class="">
                    <div class="d-flex justify-content-center">
                      <div class="icon icon-upload"></div>
                    </div>
                    <div
                      class="p-1 d-flex align-items-center justify-content-center"
                      v-if="importPlanForm.file"
                    >
                      {{ importPlanForm.fileName }}
                      <button
                        type="button"
                        class="btn btn-icon px-0 py-0"
                        aria-label="remove"
                        title="Remove file"
                        @click.stop.prevent="removePlanFile()"
                      >
                        <span class="icon icon-cross icon-cross_danger"></span>
                      </button>
                    </div>

                    <div class="mt-3" v-if="!importPlanForm.file">
                      {{ $t('addTrainingPlanByUpload') }}
                    </div>
                  </div>
                </label>
              </div>
            </validation-provider>
            <div>
              <div class="text-right mt-3" v-if="importPlanForm.file">
                <button
                  @click.prevent.stop="uploadFilePlan"
                  :disabled="importPlanForm.isLoaded"
                  class="btn btn-primary"
                >
                  {{ $t('import') }}
                </button>
              </div>
            </div>
            <!-- <span class="text-danger d-none">
              <small>{{ errors[0] }}</small>
            </span> -->
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import { mapFields } from 'vuex-map-fields'
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect'

export default {
  components: {
    Treeselect,
  },
  name: 'TrainingPlanForm',
  props: {
    title: {
      type: String,
      required: true,
    },
    trainee: {
      type: Object,
    },
  },
  data() {
    return {
      randId: `gender-id-${Math.round(Math.random() * 100)}`,
      additionalFields: false,
      isLoading: false,
      importForm: {
        isLoaded: false,
        file: null,
        fileName: '',
        alert: {
          on: false,
          type: '',
          text: '',
        },
      },
      importPlanForm: {
        isLoaded: false,
        file: null,
        fileName: '',
        alert: {
          on: false,
          type: '',
          text: '',
        },
      },
      form: {
        id: null,
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        function_id: null,
        service_id: null,
        gender: 0,
        preferred_language: null,
        pay_code: null,
        entry_date: null,
        release_date: null,
        training_manager_email: null,
        manager_email: null,
        manager_firstname: null,
        manager_lastname: null,
      },
      // services: null,
      // functions: null,
      languages: ['FR', 'EN', 'NL', 'ES', 'IT', 'DK', 'SE', 'DE'].map((i) =>
        Object.assign({}, { id: i, label: i })
      ),
      servicesSearchValue: '',
      functionsSearchValue: '',
      locale: '',
      monitor: {
        visible: false,
        message: '',
        type: '',
      },
    }
  },
  mounted() {
    this.locale = this.user.local
    const inputServices = document.querySelector(
      '#service input.vue-treeselect__input'
    )
    inputServices &&
      inputServices.addEventListener('input', (event) => {
        this.servicesSearchValue = event.target.value
        this.services = [...this.services]
      })
    const inputFunctions = document.querySelector(
      '#function input.vue-treeselect__input'
    )
    inputFunctions &&
      inputFunctions.addEventListener('input', (event) => {
        this.functionsSearchValue = event.target.value
        this.functions = [...this.functions]
      })
  },
  watch: {
    trainee() {
      this.formReset()
      this.fillForm()
    },
  },
  computed: {
    ...mapFields([
      'user',
      'establishment',
      'company',
      'trainees.services',
      'trainees.functions',
    ]),
  },
  methods: {
    removePlanFile() {
      this.importPlanForm.fileName = null
      this.importPlanForm.file = null
    },
    filePlanChange(e) {
      let files = e.target.files
      if (!files.length) return
      this.importPlanForm.fileName =
        files[0].name.length > 20
          ? files[0].name.slice(0, 20).concat('...')
          : files[0].name
      this.importPlanForm.file = files[0]
      this.importPlanForm.fileType = files[0].type
    },
    hidePlanAlert() {
      this.importPlanForm.alert.on = false
      this.importPlanForm.alert.type = ''
      this.importPlanForm.alert.text = ''
    },
    uploadFilePlan() {
      console.log('this.$refs.form.validate()', this.$refs.form.validate())
      this.hidePlanAlert()
      //  this.$refs.form.validate().then((success) => {
      /* console.log('uploadFilePlan validate',success)
        if (!success) {
          this.importPlanForm.alert.type = 'alert-danger'
          this.importPlanForm.alert.text = this.$t('errors.requiredFields')
          this.importPlanForm.alert.on = true
          setTimeout(() => {
            this.hideAlert()
          }, 1000)
          return
        }*/
      this.importPlanForm.isLoaded = true
      let formData = new FormData()
      formData.append('file', this.importPlanForm.file)
      formData.append('companyId', this.company.id)
      formData.append('establishmentId', this.establishment.id)
      console.log('upload plan', formData)

      this.$store
        .dispatch('importRegistration', formData)
        .then((response) => {
          this.importPlanForm.alert.type = 'alert-success'
          this.importPlanForm.alert.text = this.$t('savedSuccessfully')
          this.importPlanForm.alert.on = true
          setTimeout(() => {
            this.hidePlanAlert()
            this.removePlanFile()
            this.$bus.$emit('trainees-updated', false)
          }, 2000)
        })
        .catch((error) => {
          console.log(error)
          this.importPlanForm.alert.type = 'alert-danger'
          this.importPlanForm.alert.on = true
          if (error.response.status == 422) {
            this.importPlanForm.alert.text = this.$t('errors.fileType')
          } else {
            this.importPlanForm.alert.text = this.$t('savedError')
          }
          setTimeout(() => {
            this.hidePlanAlert()
          }, 2000)
        })
        .finally(() => {
          this.importPlanForm.isLoaded = false
        })

      // const formData = new FormData();
      // const fieldsParams = {};
      // formData.append( 'file', this.file );
      //formData.append( 'traineeHabilitationId', this.habilitation.id );
      // fieldsParams.trainee_id = this.habilitation.traineeId;
      // fieldsParams.traineeHabilitationId = this.habilitation.id;
      // fieldsParams.dlv = this.validUntil;
      // fieldsParams.certificate_number = this.certificateNumber;
      // this.$store
      //     .dispatch( 'habilitations/uploadHabilitationFile',   )
      //     .then( async ( resp ) => {
      //       this.$store
      //           .dispatch( 'habilitations/updateHabilitation', fieldsParams )
      //           .then( async ( resp ) => {
      //             this.alert.type = "text-success";
      //             this.alert.text = this.$t("savedSuccessfully");
      //             this.alert.on = true;
      //             setTimeout( () => {
      //               this.hideModal();
      //               this.$bus.$emit( 'update-habilitations-list', false);
      //             }, 2000 );
      //           } )
      //           .catch( ( error ) => {
      //             console.log( error );
      //             if ( error.response.status == 422 ) {
      //               this.file = null;
      //               this.alert.type = 'text-danger';
      //               this.alert.text = this.$t( 'errors.fileType' );
      //               this.alert.on = true;
      //             } else {
      //               this.file = null;
      //               this.alert.type = 'text-danger';
      //               this.alert.text = this.$t( 'errors.serverError' );
      //               this.alert.on = true;
      //             }
      //           } )
      //           .finally( () => {
      //             this.isLoaded = false;
      //           } );
      //     } )
      //     .catch( ( error ) => {
      //       console.log( error );
      //       this.isLoaded = false;
      //       if ( error.response.status == 422 ) {
      //         this.file = null;
      //         this.alert.type = 'text-danger';
      //         this.alert.text = this.$t( 'errors.fileType' );
      //         this.alert.on = true;
      //       } else {
      //         this.file = null;
      //         this.alert.type = 'text-danger';
      //         this.alert.text = this.$t( 'errors.serverError' );
      //         this.alert.on = true;
      //       }
      //     } );
      // })
    },
    fillForm() {
      this.form.id = this.trainee.id || null
      this.form.firstname = this.trainee.firstname || null
      this.form.lastname = this.trainee.lastname || null
      this.form.birthday = this.trainee.birthday || null
      this.form.email = this.trainee.email || null
      this.form.function_id = this.trainee.functionId || null
      this.form.service_id = this.trainee.serviceId || null
      this.form.gender = this.trainee.gender || 0
      this.form.preferred_language = this.trainee.preferredLanguage || null
      this.form.pay_code = this.trainee.payCode || null
      this.form.entry_date = this.trainee.entry_date || null
      this.form.release_date = this.trainee.release_date || null
      this.form.training_manager_email =
        this.trainee.training_manager_email || null
      this.form.manager_email = this.trainee.manager_email || null
      this.form.manager_firstname = this.trainee.manager_firstname || null
      this.form.manager_lastname = this.trainee.manager_lastname || null
    },
    formReset() {
      this.isLoading = false
      this.hideMessage()
      this.additionalFields = false
      this.$refs.observer.reset()
      this.form = {
        id: null,
        firstname: null,
        lastname: null,
        birthday: null,
        email: null,
        function_id: null,
        service_id: null,
        gender: 0,
        preferred_language: null,
        pay_code: null,
        entry_date: null,
        release_date: null,
        training_manager_email: null,
        manager_email: null,
        manager_firstname: null,
        manager_lastname: null,
      }
    },
    hideMessage() {
      this.monitor.visible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.dropbox {
  border: 1px dashed #979797;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 0;

  label {
    transition: 0.3s all;
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: 1rem;
    margin-bottom: 0;

    &:hover {
      background-color: #f1f4fb;
    }
  }
}

.dropbox.is-invalid {
  border: 1px dashed #ce0000;
}

.icon-upload {
  width: 24px;
  height: 24px;
}
</style>
